import { FilterConfig } from '@/shared/components/table/table.model';
import { Component, OnDestroy } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Subject } from 'rxjs';

@Component({
  selector: 'cosmos-checkbox-filter',
  templateUrl: './checkbox-filter.component.html',
  styleUrls: ['./checkbox-filter.component.scss'],
})
export class CheckboxFilterComponent implements OnDestroy {
  public _filterDescription = '';
  private readonly _filterValueSubject = new Subject<MatCheckboxChange>();
  public selectedFilter$ = this._filterValueSubject.asObservable();

  public ngOnDestroy(): void {
    this._filterValueSubject.complete();
  }

  public onFilterChange(change: MatCheckboxChange): void {
    this._filterValueSubject.next(change);
  }

  public setFilterDescription(description: string): void {
    this._filterDescription = description;
  }
}
